import { combineReducers } from 'redux';
import retailers from './license-renewal/retailers';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';


const licenseRenewal = combineReducers({
  retailers,
  isLoading: loadingStatusAccordingToReducer('licenseRenewalLoadingStatus'),
});

export default licenseRenewal;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/license-renewal.reducer.js